<template>
  <Page title="Rechnungen" color="info">
    <template slot="help">
      <Markdown :value="helpText" />
    </template>
    <template slot="extension">
      <v-tabs
        background-color="info darken-1"
        :align-with-title="!$vuetify.breakpoint.xs"
      >
        <v-tab :to="{ name: 'InvoicePending' }">
          <v-badge :content="pending" :value="pending" :color="pendingColor"
            >pendent</v-badge
          >
        </v-tab>
        <v-tab :to="{ name: 'InvoiceSubmitted' }">
          <v-badge
            :content="submitted"
            :value="submitted"
            :color="submittedColor"
            >eingereicht</v-badge
          >
        </v-tab>
        <v-tab :to="{ name: 'InvoiceNoDetails' }">
          <v-badge
            :content="noDetails"
            :value="noDetails"
            :color="noDetailsColor"
            >unverteilt</v-badge
          >
        </v-tab>
        <v-tab
          :to="{ name: 'InvoiceDepartment' }"
          v-if="$_personDepartmentFinances.includes('BG')"
        >
          <v-badge
            :content="department"
            :value="department"
            :color="departmentColor"
            >FS</v-badge
          >
        </v-tab>
        <v-tab :to="{ name: 'InvoiceArchived' }"> archiviert </v-tab>
        <v-tab :to="{ name: 'InvoiceEvents' }"> Anlässe </v-tab>
        <v-tab v-if="!isProd()" :to="{ name: 'InvoiceEvents2' }"
          >Anlässe neu</v-tab
        >
        <v-toolbar
          color="transparent"
          flat
          dense
          v-if="!$vuetify.breakpoint.xs"
        >
          <v-spacer />
          <v-text-field
            v-model="search"
            single-line
            dense
            hide-details
            label="Anlass/Beschreibung suchen"
            append-icon="mdi-magnify"
            clearable
          />
        </v-toolbar>
      </v-tabs>
    </template>
    <v-btn
      v-if="!isProd()"
      fixed
      fab
      right
      bottom
      color="danger"
      class="mr-16"
      :to="{ name: 'InvoiceNew2', params: { id: 0 } }"
      ><v-icon>mdi-plus</v-icon></v-btn
    >
    <v-btn
      fixed
      fab
      right
      bottom
      color="success"
      :to="{ name: 'InvoiceNew', params: { id: 0 } }"
      ><v-icon>mdi-plus</v-icon></v-btn
    >
    <router-view :search="search" @udpate="fetchData"></router-view>
  </Page>
</template>

<script>
const helpText = `
Die Rechnungen werden nach Nummer sortiert aufgelistet. Du kannst aber die Sortierung anpassen und nach einem Anlass oder einer Beschreibung suchen.

Um eine neue Rechnung zu erfassen verwendest du den grünen Knopf unten rechts.

**Pendente Rechnungen** sind solche, die noch nicht eingereicht wurden. Sie können von dir weiterbearbeitet werden.

**Eingereichte Rechnungen** sind solche, die du an die Buchhaltung geschickt hast. Sie können von dir nicht mehr bearbeitet werden.

**Unverteilte Rechnungen** sind solche, die ohne Personen eingereicht wurden und mittlerweile bezahlt sind. Du musst die Verteilung auf die Personen vornehmen und die Rechnung verbuchen.

**Archivierte Rechnungen** sind solche, die du fertig abgearbeitet wurden.

Unter **Anlässe** findest du abgeschlossene Rechnungen gruppiert nach Anlass.
`;
import { defineComponent } from "vue";
export default defineComponent({
  data() {
    return {
      helpText,
      pending: 0,
      pendingColor: "warning",
      submitted: 0,
      submittedColor: "info",
      noDetails: 0,
      noDetailsColor: "danger",
      department: 0,
      departmentColor: "danger",
      search: "",
    };
  },
  methods: {
    async fetchData() {
      const overview = await this.apiList({
        resource: "finance/invoiceoverview",
      });
      this.pending = overview.created + overview.rejected;
      this.pendingColor = overview.rejected ? "danger" : "warning";
      this.submitted =
        overview.foreign + overview.submitted + overview.submittedSap;
      this.noDetails = overview.noDetails;
      this.department = overview.department;
    },
  },
  created() {
    this.fetchData();
  },
});
</script>
